import React from 'react';
import {useSelector} from "react-redux";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import '../index.css'
import Typewriter from '../../../../comm/textShow'
import Answer2 from "./sse";


const DictionaryAnswer = (props) =>  {

    const {answer,sendTxt,setSendTxt} = props
    const data = answer?.content;
    const {size} = useSelector(state => state.fontSizeChange)
    const answerThree = {
        fontSize: size === '小' ? '14px' : (size === '中' ? '16px' : '18px'),
        paddingTop:'5px',
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    }
    return (
        <div>
                {
                    answer&&answer.length>0?
                    answer.map((res,i)=>{
                        return (
                            <div style={answerThree} key={'tran-an'+i}>
                                {
                                    answer?.textShow?<Typewriter text={res.text}/>:<span>{res.text}</span>
                                }
                                {/*<ReactMarkdown remarkPlugins={[remarkGfm]}>*/}
                                {/*    {res.text.replace('/\n/g','<br/>')}*/}
                                {/*</ReactMarkdown>*/}
                            </div>
                        )
                    }):''
                }
        </div>
    );
}


export default DictionaryAnswer
